// extracted by mini-css-extract-plugin
export default {"loaderCenter":"AdminLoader_loaderCenter__XLweu"};